import React from 'react';
import { IconArrowUpRegular } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';
import { FaceButton, FaceButtonSize } from '@common/toolbox';

import { transientOptions } from '../utils/transientOptions';

interface Props {
  is_opener?: boolean;
}

export const DescToggleButton = ({ is_opener }: Props) => {
  return (
    <Container data-allow-preview>
      <Button className={Typography.BODY_15_SEMIBOLD} size_type={FaceButtonSize.S15_H48}>
        {is_opener ? '상품정보 더 보기' : '상품정보 접기'}
      </Button>
      <ArrowIcon width={20} height={20} $is_opener={is_opener} v3Color='gray950' />
    </Container>
  );
};

const Container = styled.div`
  border: 1px solid ${vars.v3Color.gray900};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  border-radius: 100px;
`;

const Button = styled(FaceButton)`
  pointer-events: none;

  span {
    font-weight: 600 !important;
  }
`;

const ArrowIcon = styled(IconArrowUpRegular, transientOptions)<{ $is_opener?: boolean }>`
  margin-left: 3px;
  pointer-events: none;

  ${({ $is_opener }) => $is_opener && 'transform: rotate(180deg);'}
`;
